module.exports = __webpack_public_path__ + "img/fastcharger-realized-semipublic.cd1e9d0e.svg";